import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetProjectStatusModel, ProjectStatusArrayModel, ProjectStatusModel } from "../../models/ProjectStatusModel";

const initialProjectStatusState: ProjectStatusArrayModel = {
    projectStatusObject: {
        "projectStatusID": 0,
        "projectID": 0,
        "isSavedAsDraft": false,
        "savedAsDraftByUserID": 0,
        "isDrafted": false,
        "draftedByUserID": 0,
        "isSubmitted": false,
        "submittedByUserID": 0,
        "isSBUApproved": false,
        "sbuApproverUserID": 0,
        "isSBGApproved": false,
        "sBGApproverUserID": 0,
        "isCSGOApproved": false,
        "csgoApproverUserID": 0,
        "isRejected": false,
        "rejectedUserID": 0,
        "rejectedComment": "",
        "isCompleted": false
    },
    getProjectStatusArrayObject: [],
}
const ProjectStatusSlice = createSlice({
    name: 'ProjectStatus',
    initialState: initialProjectStatusState,
    reducers: {
        setParticularProjectStatus(state, action: PayloadAction<ProjectStatusModel>) {
            state.projectStatusObject = action.payload;
        },
        getProjectStatusAdmin(state, action: PayloadAction<GetProjectStatusModel[]>) {
            state.getProjectStatusArrayObject = action.payload
        }
    }
})
export default ProjectStatusSlice;